import { Link } from 'react-router-dom';

export default function Footer() {
  const contactEmail = (import.meta.env.VITE_CONTACT_EMAIL as string | undefined) || 'hello@knotiv.com';

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <div className="footer-small">
            © {new Date().getFullYear()} Knotiv. All rights reserved.
          </div>
          <div className="footer-small footer-meta">
            <Link className="link" to="/privacy">
              Privacy Policy
            </Link>
            <span>·</span>
            <span>
              Contact:{' '}
              <a className="link" href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
